import { object } from "prop-types";
import React from "react";

import ThreeColGrid from "../../../../arrow/components/Rows/ThreeColGrid";
import { BrowserView } from "react-device-detect";
import { DfpComponent } from "../../../ads/dfp-component";
import { useSelector } from "react-redux";
import { get } from "lodash";

import "./style.m.css";

export const ArrowThreeColGrid = ({ collection }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const networkId = get(qtState, ["config", "ads-config", "network_id"], {});

  const theme = ["photos", "videos"].includes(collection.slug) ? "#000000" : "";
  const isVideoTemplate = ["photos", "videos"].includes(collection.slug);
  const footerSlot = (
    <>
      <BrowserView>
        <DfpComponent
          adStyleName="ad-style-300x250"
          id={`${collection?.slug}-template-ad`}
          path={`/${networkId}/RPSG_Opn_Desktop/RPSG_Opn_HOM_Desk_mREC`}
          adSlotConfigName="mRec_ad"
          showText={true}
        />
      </BrowserView>
    </>
  );
  const config = {
    buttonText: `Read More`,
    theme: theme,
    showImagePlaceholder: true,
    showSection: false,
    showReadTime: false,
    slotConfig: [
      {
        type: "ad",
        component: () => footerSlot,
      },
    ],
  };

  return (
    <div styleName={`${isVideoTemplate ? "video" : ""}`}>
      <ThreeColGrid
        collection={collection}
        config={config}
        template=""
        isLoadMoreVisible={true}
        showAuthorContent={false}
      />
    </div>
  );
};

ArrowThreeColGrid.propTypes = {
  collection: object,
};

ArrowThreeColGrid.storyLimit = 16;
